import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useOmakasePlanStrategies, useOmakasePlanStrategy } from 'shared-modules/services/hooks/omakasePlanLogic';
import { STRATEGY_SET_ALL_ZERO } from 'shared-modules/constants/errorMesages';
import styles from './strategiesList.module.scss';
import { InputNumber } from '../../../../../../../components';
import { MarginText } from '../../../../../../../components/Texts';
import InstrumentIcon from '../../../../../../../components/InstrumentIcon';
import { openConfirmationModal } from '../../../../../../../redux/actions';

const StrategyCard = memo(({ strategy }) => {
  const dispatch = useDispatch();

  const finalStrategyErrorCallback = useCallback(() => {
    dispatch(
      openConfirmationModal({
        title: STRATEGY_SET_ALL_ZERO.title,
        bodyText: STRATEGY_SET_ALL_ZERO.body,
        buttonNextText: STRATEGY_SET_ALL_ZERO.buttonText,
        isOverlap: true,
      }),
    );
  }, [dispatch]);

  const { count, marginRequired } = useOmakasePlanStrategy(strategy, finalStrategyErrorCallback);
  const { strategyDetail } = strategy;
  const { instrumentId, serviceId, name } = strategyDetail;

  return (
    <div className={styles.strategyCardContainer}>
      <div className={styles.infoContainer}>
        <div className={styles.iconContainer}>
          <InstrumentIcon className={styles.icon} size="small" instrumentId={instrumentId} serviceId={serviceId} />
        </div>
        <div className={styles.strategyInfoContainer}>
          <div className={styles.nameText}>{name}</div>
          <MarginText value={marginRequired} className={styles.priceText} />
        </div>
        <div className={styles.setInputContainer}>
          <InputNumber
            className={styles.numberInput}
            buttonStyle={styles.numberInputButton}
            inputStyle={styles.inputStyle}
            name={count.name}
            value={count.get}
            onChange={count.set}
            validateFunction={count.validation}
            errorMessages={count.error}
            minByDecrement={0}
            withErrorTooltip
            onlyIntegerAllowed
            width={43}
          />
        </div>
      </div>
    </div>
  );
});

StrategyCard.propTypes = {
  strategy: PropTypes.shape({
    strategyId: PropTypes.number.isRequired,
    strategyDetail: PropTypes.shape({
      serviceId: PropTypes.string.isRequired,
      instrumentId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const StrategiesList = () => {
  const { resetSetCountBtn, strategyList } = useOmakasePlanStrategies();

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {strategyList.map((item) => (
          <StrategyCard strategy={item} key={item.strategyId} />
        ))}
      </div>
      <div className={styles.resetButtonArea}>
        <button className={styles.resetButton} type="button" onClick={() => resetSetCountBtn.onClick()}>
          <i className={classNames('material-icons', styles.icon)}>replay</i>
          <span className={styles.resetText}>{resetSetCountBtn.label}</span>
        </button>
      </div>
    </div>
  );
};

export default memo(StrategiesList);
